<template>
    <div class="hz-emotion">
        <button v-for="(item,index) in list">
            <img class="hz-static-emotion" @click="emotionSelect(item,index)"
                 :src="faceUrl+index+'.png'">
        </button>
    </div>
</template>

<script>
    import {faceUrl} from "@/config/env"
    import emojiList from '@/util/emoji'

    export default {
        name: 'emotion',
        props:{
          showEmoji:Boolean,
        },
        data() {
            return {
                faceUrl: faceUrl,
                list: []
            }
        },
        watch:{
          showEmoji(){
            if(this.list.length==0){
              this.list = emojiList
            }
          }
        },
        mounted() {
            // this.list = emojiList
        },
        methods: {
            emotionSelect(item, index) {
                this.$emit('handleEmotion', item)
            }
        }
    }
</script>
<style scoped lang="scss">
    .hz-emotion{
        display: inline-block;
        text-align: left;
        line-height: 20px;
        padding: 5px;
        .hz-static-emotion {
            width: 24px;
            height: 24px;
            display: inline-block;
            margin-left: 5px;
        }
        button {
            margin: 0;
            padding: 0;
            border: 1px solid transparent;
            background: none;
            outline: none;
        }
    }


</style>
